<template>
  <div class="company-manage-log" v-loading="loading">
    <div class="title">管理日志</div>
    <div class="option-row">
      <div class="filter-wrap">
        <div>
          操作时间
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="getLogs"
          ></el-date-picker>
        </div>
        <div style="margin-left: 20px">
          操作类型
          <el-cascader
            v-model="type"
            :options="typeOptions"
            :props="{ checkStrictly: true }"
            clearable
            @change="getLogs"
          ></el-cascader>
        </div>
        <div style="margin-left: 20px">
          <span style="float: left; margin: 6px;">操作人员</span>
          <user-selector
            style="float: left; width: 200px"
            v-model="staff"
            filterable
            @change="getLogs"
          ></user-selector>
        </div>
      </div>
      <base-button type="primary" style="float: right;" @click="exportLogs">
        导出
      </base-button>
    </div>
    <section class="main-wrap">
      <base-table
        ref="BaseTable"
        tableHeight="100%"
        :data="logs"
        :page-info="pageInfo"
        @page-change="refresh"
      >
        <el-table-column
          v-for="item in logColumns"
          :key="item.value"
          :label="item.label"
          :width="item.width"
          :column-key="item.value"
          show-overflow-tooltip
        >
          <template v-slot:header>
            <span v-tip>{{ item.label }}</span>
          </template>
          <template slot-scope="scope">
            <template v-if="item.value === 'extra'">
              <template v-if="_.isPlainObject(_.get(scope.row, 'extra'))">
                {{ _.get(scope.row, "extra").content }}
                <el-button
                  type="text"
                  style="margin-left: 6px;"
                  @click="downloadResult(_.get(scope.row, 'extra').url)"
                >
                  下载查看导出结果
                </el-button>
              </template>
              <template v-else-if="_.isArray(_.get(scope.row, 'extra'))">
                {{ editCompanyUserLog(scope.row.extra) }}
              </template>
              <template v-else>
                {{ _.get(scope.row, "extra") }}
              </template>
            </template>
            <template v-else>
              {{ _.get(scope.row, item.value) }}
            </template>
          </template>
        </el-table-column>
      </base-table>
    </section>
  </div>
</template>
<script>
import { getCurCompany } from "@/api/userCenter/company"
import { exportCompanyLog, getCompanyLogList } from "@/api/user"
import { logColumns, typeOptions, typeMap } from "@/views/Company/Manage/DataSecurity/static"
import BaseTable from "@/components/UIComponents/BaseTable"
import BaseButton from "@/components/UIComponents/Button"
import UserSelector from "@/components/FormControl/UserSelector"
export default {
  name: "company-manage-log",
  components: {
    BaseTable,
    BaseButton,
    UserSelector
  },
  data() {
    return {
      loading: false,
      logColumns,
      typeOptions,
      typeMap,
      currentCompany: {},
      pageInfo: {
        total: 1,
        currentPage: 0,
        pageSize: 20
      },
      date: [],
      type: [],
      staff: [],
      logs: []
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      getCurCompany()
        .then(currentCompany => {
          this.currentCompany = currentCompany
        })
        .then(() => {
          getCompanyLogList({
            businessId: this.currentCompany.id,
            endTime: this.date && this.date.length ? this.date[1] : null,
            page: this.pageInfo.currentPage,
            size: this.pageInfo.pageSize,
            startTime: this.date && this.date.length ? this.date[0] : null,
            type: this.type.length === 2 ? this.type[1] : null,
            typeGroup: this.type.length ? this.type[0] : null,
            userId: this.staff.length ? this.staff[0] : null
          }).then(res => {
            this.logs = res.content.map(t => {
              t.typeZh = this.typeMap[t.type]
              return t
            })
            this.pageInfo.total = res.totalElements
            this.loading = false
          })
        })
    },
    exportLogs() {
      exportCompanyLog({
        businessId: this.currentCompany.id,
        endTime: this.date.length ? this.date[1] : null,
        page: this.pageInfo.currentPage,
        size: this.pageInfo.pageSize,
        startTime: this.date.length ? this.date[0] : null,
        type: this.type.length === 2 ? this.type[1] : null,
        typeGroup: this.type.length ? this.type[0] : null,
        userId: this.staff.length ? this.staff[0] : null
      }).then(() => {
        this.$message.success("操作成功")
      })
    },
    getLogs() {
      this.refresh()
    },
    downloadResult(url) {
      window.open(url)
    },
    // 编辑成员 特殊处理
    editCompanyUserLog(logArr) {
      if (this._.isEmpty(logArr)) return "空"
      let row0 = logArr[0]
      return (
        `${row0.ctrlName}: ${row0.oldStr}。` +
        logArr
          .slice(1)
          .map(row => `${row.ctrlName}: ${row.oldStr || ""} -> ${row.newStr || ""}`)
          .join("；")
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.company-manage-log {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .title {
    font-size: $font-size-title-first;
    padding: 0 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .option-row {
    display: flex;
    align-items: center;
    .filter-wrap {
      display: flex;
      margin: 10px 20px;
      font-size: 14px;
      .el-cascader {
        line-height: 0;
      }
    }
    .base-button {
      margin-right: 20px;
      margin-left: auto;
    }
  }
  .main-wrap {
    flex: 1 1;
    overflow: hidden;
    .base-table {
      height: 100%;
    }
  }
  ::v-deep {
    .el-divider--horizontal {
      margin: 10px 0;
    }
    .el-range-editor--small.el-input__inner {
      width: 240px;
    }
    .user-scope-selector-container {
      .value-wrapper {
        min-height: 30px;
      }
    }
  }
}
</style>
